import domready from "domready";
import * as React from "react";
import { createRoot } from 'react-dom/client';
import { configureStore } from "@reduxjs/toolkit";
import { Provider, useDispatch } from "react-redux";
import { apiMiddleware } from "redux-api-middleware";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { createS3SearchReducer } from "../Search/SearchReducer";
import { loadStops, setDestination, setOrigin } from "../Search/Actions";
import { StopSelector } from "../Components/StopSelector";
import { ISearchState } from "../Models";
import { dispatchCustomEvent } from "../../Shared/CustomEvents";
import { useGenericSelector } from "../../Shared/Redux";
import { getAccessToken } from "../Settings";


//Hårt typad selector till vårt appstate
function useStateSelector<T>(selectorFunc: (state: ISearchState) => T) { return useGenericSelector((state :ISearchState) => selectorFunc(state)); }

const strings = getStrings().component.searchForm;


export const App = () => {
	const stops = useStateSelector(state => state.stops);
	const origin = useStateSelector(state => state.origin);
	const destination = useStateSelector(state => state.destination);

	const dispatch = useDispatch();

	const isValid: boolean = (origin && destination) != null;

	//För att se till att lågpriskalendern redan är laddad när vi öppnar
	//bokningsdialogen triggar vi en hämtning av den så fort vi valt två locations.
	//Det gör att den cachas i session storage och hämtas omgående sedan.
	// useEffect(() => {
	// 	if (fromLocation && toLocation) {
	// 		dispatch(loadDepartureCalendar(fromLocation, toLocation));
	// 	}
	// }, [fromLocation, toLocation])


	// function locationSelected(location: ILocation, direction: "from"|"to") {
	// 	dispatch(selectLocation(location, direction));
	// }

	function searchClicked() {
		if (!isValid)
			return;

		const event = new CustomEvent("Search", { detail: { origin, destination } });
		dispatchCustomEvent(event);
	}


	return (<div className="location-form search-form">
		<StopSelector label={<span>{strings.travelFrom}</span>} stops={stops} selected={origin} disabledStop={destination} disabled={!stops} onStopSelected={stop => dispatch(setOrigin(stop))} placeholder={strings.travelFromPlaceholder} />
		<StopSelector label={<span>{strings.travelTo}</span>} stops={stops} selected={destination} disabledStop={origin} disabled={!stops} onStopSelected={stop => dispatch(setDestination(stop))} placeholder={strings.travelToPlaceholder} />
		<div>
		<button type="button" className="btn btn-primary" disabled={!isValid} onClick={() => searchClicked()}>{strings.searchButtonText}</button>
		</div>
	</div>);
};

domready(() => {
	const element = document.getElementById("reservation-box");

	if (!element)
		return;

	// const frequentLocations = JSON.parse(element.getAttribute("data-frequent-locations") || "[]") as ILocation[];

	// const searchParams = new URLSearchParams(window?.location.search);

	// const to = frequentLocations.find(x => x.locationId === parseInt(searchParams.get("to") || "-1"));
	// const from = frequentLocations.find(x => x.locationId === parseInt(searchParams.get("from") || "-1"));

	//Tagit bort devtools, eftersom den väljs före ReservationDialog, och det är nästan alltid den man vill åt!
	//Om vi börjar jobba med denna igen får vi aktivera devtools igen!
	const store = configureStore({
		reducer: createS3SearchReducer(),
		middleware: (getDefaultMiddleware) => [apiMiddleware, ...getDefaultMiddleware({ serializableCheck: true })],
		devTools: {name: "QuickSearchBox"}
	});

	//Ladda initial data
	setTimeout(async () => {
		await getAccessToken();
		store.dispatch(loadStops());
	}, 0);

	const root = createRoot(element);
	root.render(
		<Provider store={store}>
			<App />
		</Provider>);
});

